<div class="dashboard-summary-widget-content" [ngClass]="{'p-jc-center': (!selectedReportFilters?.summaryWidgetCode || loadingReport) }">
    <div *ngIf="loadingReport" class="dashboard-charts p-d-flex">
        <app-block-content-spinner  height="100%" style="width: 100%"></app-block-content-spinner>
    </div>
    <ng-container *ngIf="!selectedReportFilters?.summaryWidgetCode && !loadingReport">
        <button pButton icon="pi pi-plus" label="Add Widget Content" (click)="displayFilterPopup=true"></button>
    </ng-container>
    <ng-container *ngIf="selectedReportFilters?.summaryWidgetCode && !loadingReport">
        <div class="dashboard-summary-widget-left">
            <span class="dashboard-summary-widget-icon {{reportIcon||'pi pi-chart-line'}}"></span>
        </div>
        <div class="dashboard-summary-widget-right">
            <div class="dashboard-summary-widget-header">
                {{ reportName }}
            </div>
            <div class="dashboard-summary-widget-counts">
                {{ reportResultValue  | number: "1.2-2" | currencySymbol }}
            </div>
        </div>
    </ng-container>
</div>

<p-dialog [header]="filterPopupHeader" (onHide)="cancelFilterPopup()" [(visible)]="displayFilterPopup" [modal]="true"
    [style]="{width: '400px'}" appendTo="body">
    <ng-template pTemplate="content">
        <form [formGroup]="filterForm" novalidate>
            <div class="p-grid" style="flex-grow: 1;">
                <div class="p-col-12">
                    <h6 class="p-mb-1">Select Summary Widget</h6>
                    <liono-treeSelect class="w-100"
                        (onNodeSelect)="changeWidget($event)"
                        [options]="summaryWidgetList" appendTo="body"
                        formControlName="selectedWidget"
                        display="comma"
                        placeholder="Select Summary Widget"
                        [metaKeySelection]="false" selectionMode="single">
                    </liono-treeSelect>
                    <div *ngIf="detailsFormErrors?.selectedWidget" class="p-invalid">
                        <small>{{ detailsFormErrors?.selectedWidget }}</small>
                    </div>
                </div>
                <div class="p-col-12">
                    <h6 class="p-mb-1">Select Date</h6>
                    <p-dropdown [options]="filterDataByTime" (onChange)="changeRange($event, true)"
                         id="rangeItems" [style]="{'width':'100%'}"
                        formControlName="selectedDateFilter" optionLabel="label" appendTo="body"
                        placeholder="Select Date">
                        <ng-template let-item pTemplate="selectedItem">
                           {{ asOfDateReports.includes(filterForm.value.selectedWidget?.key) && item.code!='custom' ? 'As Of ' : ''}}{{item.label}}
                        </ng-template>
                        <ng-template let-item pTemplate="item">
                            {{ asOfDateReports.includes(filterForm.value.selectedWidget?.key) && item.code!='custom' ? 'As Of ' : ''}}{{item.label}}
                        </ng-template>
                    </p-dropdown>
                    <div *ngIf="detailsFormErrors?.selectedDateFilter" class="p-invalid">
                        <small>{{ detailsFormErrors?.selectedDateFilter }}</small>
                    </div>
                </div>
                <ng-container *ngIf="!asOfDateReports.includes(filterForm.value.selectedWidget?.key) || filterForm.value.selectedDateFilter?.code=='custom'">
                    <div class="p-col-12">
                        <h6 class="p-mb-1">From Date</h6>
                        <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                            dateFormat="mm/dd/yy" yearRange="1900:2100"
                            formControlName="dateFrom" [maxDate]="filterForm.getRawValue().dateTo"
                            [disabled]="filterForm.value.selectedDateFilter?.code !== 'custom'" [style]="{'width':'100%'}"
                            [inputStyle]="{'width':'100%'}">
                        </p-calendar>
                    </div>
                    <div class="p-col-12">
                        <h6 class="p-mb-1">To Date</h6>
                        <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                            dateFormat="mm/dd/yy" yearRange="1900:2100"
                            formControlName="dateTo" [minDate]="filterForm.getRawValue().dateFrom"
                            [disabled]="filterForm.value.selectedDateFilter?.code !== 'custom'" [style]="{'width':'100%'}"
                            [inputStyle]="{'width':'100%'}">
                        </p-calendar>
                    </div>
                </ng-container>
                <div class="p-col-12">
                    <h6 class="p-mb-1">Select Background</h6>
                    <div class="layout-themes">
                        <div *ngFor="let f of summaryWidgetThemes">
                            <a style="cursor: pointer" title="{{f.name}}" (click)="selectTheme(f.name)" [ngStyle]="{'background-color': f.color}">
                                <i class="pi pi-check" *ngIf="filterForm.value.selectedTheme === f.name"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="p-col-12">
                    <h6 class="p-mb-1">Enter Summary Title</h6>
                    <input type="text" pInputText formControlName="reportName" placeholder="Summary Title">
                    <div *ngIf="detailsFormErrors?.reportName" class="p-invalid">
                        <small>{{ detailsFormErrors?.reportName }}</small>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>
    <p-footer>
        <button type="button" pButton label="Cancel" (click)="cancelFilterPopup()" class="p-button-secondary"></button>
        <button type="submit" pButton label="Apply"
            (click)="applyAllFilters(reportsAllFiltersApplyModes.applyOnly)"></button>
        <button type="submit" pButton label="Apply & Save"
            (click)="applyAllFilters(reportsAllFiltersApplyModes.applySave)"></button>
    </p-footer>
</p-dialog>
